import { render } from "./HeaderFullMenu.vue?vue&type=template&id=5645860c&scoped=true"
import script from "./HeaderFullMenu.vue?vue&type=script&lang=js"
export * from "./HeaderFullMenu.vue?vue&type=script&lang=js"

import "./HeaderFullMenu.vue?vue&type=style&index=0&id=5645860c&scoped=true&lang=css"

import exportComponent from "/OfficialWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5645860c"]])

export default __exports__